import axios from 'axios';
import store from '@/store';
import System from '@/models/system';

export default {
    isExcludedRoute(route) {
        let excludedRoutes = ['/login', '/password/forgot', '/password/reset'];

        return Boolean(
            excludedRoutes.find(function (value) {
                return route.includes(value);
            })
        );
    },
    init() {
        store.dispatch('system/updateEpicVaultModule', window.is_epicvault_enabled);
        store.dispatch('system/updateDisplayNotice', false);
        store.dispatch('system/updateInitialized', false);
        store.dispatch('user/forceLogin');

        this.me();
    },
    me() {
        axios
            .get('/api/me')
            .then((response) => {
                this.setUserInfo(response.data.data);
            })
            .catch((error) => {
                // 401 if not logged in
            })
            .finally(() => {
                if (System.isCoverPublic(window.location.pathname)) {
                    store.dispatch('system/updateInitialized', true);
                } else if (!store.state.user.is_logged_in && !this.isExcludedRoute(window.location.pathname)) {
                    System.resetData();
                    window.location.href = '/login';
                } else if (store.state.user.is_logged_in && this.isExcludedRoute(window.location.pathname)) {
                    if (
                        store.state.user.default_landing_page == 'claimsvault' &&
                        store.state.user.enable_advanced_claims_analytics
                    ) {
                        window.location.href = '/claims';
                    } else if (
                        store.state.user.default_landing_page == 'covervault' &&
                        store.state.user.enable_advanced_cover_analytics
                    ) {
                        window.location.href = '/covers';
                    } else {
                        window.location.href = '/';
                    }
                } else {
                    store.dispatch('system/updateInitialized', true);
                }
            });
    },
    can(ability) {
        return store.state.user.abilities.includes(ability);
    },
    isCurrentUser(id) {
        return store.state.user.id == id;
    },
    setUserInfo(data) {
        store.dispatch('user/updateUser', {
            id: data.id,
            email: data.email,
            name: data.name,
            is_logged_in: data.is_logged_in,
            tfa_type: data.tfa_type,
            is_tfa_enabled: data.is_tfa_enabled,
            is_company_tfa_enabled: data.is_company_tfa_enabled,
            is_association_tfa_enabled: data.is_association_tfa_enabled,
            tfa_processed: data.tfa_processed,
            is_change_password: data.is_change_password,
            is_multi_association_access: data.is_multi_association_access,
            module_state: data.module_state,
            modules: data.modules,
            association: data.association,
            company: data.company,
            abilities: data.abilities,
            association_list: data.association_list,
            default_landing_page: data.default_landing_page,
            claimsvault_analytics_url: data.claimsvault_analytics_url,
            covervault_analytics_url: data.covervault_analytics_url,
            is_module_claimsvault_enabled: data.is_module_claimsvault_enabled,
            is_module_covervault_enabled: data.is_module_covervault_enabled,
            enable_advanced_claims_analytics: data.enable_advanced_claims_analytics,
            enable_advanced_cover_analytics: data.enable_advanced_cover_analytics,
            claims_detail_layout: data.claims_detail_layout,
            roles: data.roles,
        });
    },
    changeAssociation(association_id) {
        _.forEach(store.state.user.association_list, function (association, key) {
            if (association.id == association_id) {
                store.dispatch('user/updateCurrentAssociation', association);

                window.location.href = '/';
            }
        });
    },
};
